import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';

const withRsSlidableNavigationHandlers = () => {
  return (Component) => {
    function SlidableNavigationHandlersHOC(props) {
      const {
        containerElement,
        contentOffset,
        applyContentOffset,
        prevDisabled,
        nextDisabled,
        itemsElements,
        visibleItemIndex,
        ...otherProps
      } = props;

      // index of the current most left item that is still within container
      const getCurrentIndex = () => {
        return findIndex(itemsElements, (item) => item.offsetLeft + contentOffset >= 0);
      };

      const goToIndex = (index) => {
        const itemAtIndex = itemsElements[index];
        if (itemAtIndex) {
          applyContentOffset(-itemAtIndex.offsetLeft); // negative offset
        }
      };

      // make item with visibleItemIndex visible
      useEffect(() => {
        const visibleItem = itemsElements[visibleItemIndex]; // item to make visible

        if (!visibleItem) {
          return;
        }

        const containerWidth = containerElement.offsetWidth;
        const visibleItemOffset = visibleItem.offsetLeft;

        if (visibleItemOffset + contentOffset < 0 || visibleItemOffset + contentOffset >= containerWidth) {
          goToIndex(visibleItemIndex);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [visibleItemIndex]);

      const goPrev = () => {
        const prevIndex = Math.max(getCurrentIndex() - 1, 0);
        goToIndex(prevIndex);
      };

      const goNext = () => {
        const nextIndex = Math.min(getCurrentIndex() + 1, itemsElements.length - 1);
        goToIndex(nextIndex);
      };

      return <Component prevDisabled={prevDisabled} nextDisabled={nextDisabled} goPrev={goPrev} goNext={goNext} {...otherProps} />;
    }

    SlidableNavigationHandlersHOC.propTypes = {
      prevDisabled: PropTypes.bool,
      nextDisabled: PropTypes.bool,
      containerElement: PropTypes.object,
      contentOffset: PropTypes.number,
      applyContentOffset: PropTypes.func,
      itemsElements: PropTypes.array,
      visibleItemIndex: PropTypes.number,
    };

    return SlidableNavigationHandlersHOC;
  };
};

export default withRsSlidableNavigationHandlers;
